import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'recoil-persist-layout',
  storage: localStorage,
});

export type ColumnComponent = 'orderbook' | 'chart-history' | 'tradeform';
export type CenterSubComponent = 'chart' | 'history';

// [left, center, right] column slot assignments
export const columnPositionsAtom = atom<[ColumnComponent, ColumnComponent, ColumnComponent]>({
  key: 'columnPositions',
  default: ['orderbook', 'chart-history', 'tradeform'],
  effects_UNSTABLE: [persistAtom],
});

// [top, bottom] within the chart-history group
export const centerOrderAtom = atom<[CenterSubComponent, CenterSubComponent]>({
  key: 'centerOrder',
  default: ['chart', 'history'],
  effects_UNSTABLE: [persistAtom],
});
